import { toast } from 'react-toastify';
import { JAVA_API_STATUS } from '../../../utils/axios-interceptor';
import { fetchBankStatementDataService, downloadBankStatementSummaryService } from './service';

export async function fetchBankStatementData(payload, handlers) {
    try {
        const response = await fetchBankStatementDataService();
        const responseData = response.data?.responseData;
        switch (responseData?.responseCode) {
            case JAVA_API_STATUS.SUCCESS:
                handlers?.onSuccess(response.data?.bankData || {});
                return;
            case JAVA_API_STATUS.ERROR:
                handlers?.onError?.();
                return toast.error(responseData?.responseMessage || 'Some error occoured');
        }
    } catch (err) {
        handlers?.onError();
        console.error('Error in fetching bank statement data', err);
    }
}

export async function downloadBankStatementSummary(
    investeeOrgId: string,
    dataType: string = 'summary',
    handlers?: { onSuccess?: (blob: Blob) => void; onError?: () => void },
) {
    try {
        const response = await downloadBankStatementSummaryService(investeeOrgId, dataType);

        if (response.data) {
            // Create a download link for the blob
            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `bank-statement-summary-${investeeOrgId}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            handlers?.onSuccess?.(blob);
            toast.success('Bank statement summary downloaded successfully');
        } else {
            handlers?.onError?.();
            toast.error('No data received for download');
        }
    } catch (err) {
        handlers?.onError?.();
        console.error('Error in downloading bank statement summary', err);
        toast.error('Failed to download bank statement summary');
    }
}
